/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Maintainer_TitleInputs */

const en_contact_maintainer_title = /** @type {(inputs: Contact_Maintainer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who maintains this site`)
};

const ko_contact_maintainer_title = /** @type {(inputs: Contact_Maintainer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 사이트의 운영자`)
};

const ja_contact_maintainer_title = /** @type {(inputs: Contact_Maintainer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このサイトの運営者`)
};

/**
* | output |
* | --- |
* | "Who maintains this site" |
*
* @param {Contact_Maintainer_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const contact_maintainer_title = /** @type {((inputs?: Contact_Maintainer_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Maintainer_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_maintainer_title(inputs)
	if (locale === "ko") return ko_contact_maintainer_title(inputs)
	return ja_contact_maintainer_title(inputs)
});